import { Pipe, PipeTransform } from '@angular/core';
import { Status } from '../../core/models/status.model';

@Pipe({
  name: 'status'
})
export class StatusPipe implements PipeTransform {
  transform(value: any): any {
    switch (value) {
      case 1: return 'تایید شده';
      case 2: return 'رد شده';
      case 3: return 'در انتظار';
      case 4: return 'منقضی شده';
      case 5: return 'درخواست تمدید';
    }
    return 'نامشخص';
  }
}
